module.exports = __webpack_public_path__ + "img/album18_49.03beb677.jpg";